// src/Components/Dashboard/MenuList.jsx
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { ChevronRight, CheckCircle } from "lucide-react";

const MenuList = ({ menus, selectedMenu, onMenuSelect, title }) => {
    const { t } = useTranslation();

    const handleMenuClick = (menuId, menuName) => {
        localStorage.setItem('selectedMenu', menuId);
        localStorage.setItem('selectedMenuName', menuName);
        onMenuSelect(menuId);

        // Dispatch custom event om Header te updaten
        window.dispatchEvent(new Event('menuChanged'));
    };

    return (
        <div className="mb-8 mt-[50px] overflow-y-auto max-h-[50vh]">
            <h2 className="text-xl font-normal mb-4 font-inter text-ps-blue-dark">
                {title || t('dashboard.menus')}
            </h2>
            
            {menus.length === 0 ? (
                <div className="text-center py-8 text-gray-500 font-inter">
                    <p>{t('messages.noMenusFound')}</p>
                    <p className="text-sm mt-2">
                        {t('messages.createFirstMenu')}
                    </p>
                </div>
            ) : (
                <div className="space-y-2">
                    {menus.map((menu) => (
                        <div
                            key={menu.id}
                            className="flex items-center justify-between w-full p-4 hover:pl-6 cursor-pointer border-b-[1px] transition-all duration-200 hover:bg-gray-50"
                            onClick={() => handleMenuClick(menu.id, menu.name)}
                        >
                            <div className="flex items-center gap-3">
                                <CheckCircle
                                    className={`transition-colors ${
                                        selectedMenu === menu.id 
                                            ? 'text-green-600' 
                                            : 'text-gray-400'
                                    }`}
                                    size={20}
                                />
                                <span className="font-inter">{menu.name}</span>
                                {selectedMenu === menu.id && (
                                    <span className="text-xs bg-ps-green text-white px-2 py-1 rounded-full">
                                        {t('common.active')}
                                    </span>
                                )}
                            </div>
                            <ChevronRight 
                                className="text-ps-blue-dark transition-transform group-hover:translate-x-1" 
                                size={20} 
                            />
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

MenuList.propTypes = {
    menus: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number.isRequired,
            name: PropTypes.string.isRequired,
        })
    ).isRequired,
    selectedMenu: PropTypes.number,
    onMenuSelect: PropTypes.func.isRequired,
    title: PropTypes.string,
};

export default MenuList;